__turbopack_context__.v({
  "disabled": "wRFI-q_disabled",
  "outlined": "wRFI-q_outlined",
  "supportingLabel": "wRFI-q_supportingLabel",
  "switch": "wRFI-q_switch" + " " + __turbopack_context__.i(248112)["resetFocusOutline"],
  "textWrapper": "wRFI-q_textWrapper",
  "wrapper": "wRFI-q_wrapper" + " " + __turbopack_context__.i(248112)["focusWithinOutline"],
});
